import { LogoOndernemersplein } from '@/uiIcons/LogoOndernemersplein';
import { LogoBusinessGov } from '@/uiIcons/LogoBusinessGov';
import { FunctionComponent, type JSX } from 'react';
import { project } from '@/globals/config/helpers/configEnvironment';
import { Project } from '@/globals/config/helpers/configEnvironment.types';

const SiteLogos = {
	op: LogoOndernemersplein,
	bgov: LogoBusinessGov,
} as const satisfies {
	[Key in Project]: FunctionComponent<JSX.IntrinsicElements['svg']>;
};
export const SiteLogo = SiteLogos[project];
